<template>
  <div class="lvItemTime">
    <div class="whileBlock">{{ low }}</div>
    <div class="whileBlock">{{ height }}</div>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "lvItemTime",
  props: {
    title:{type: String, required: true},
    num:{type: Number, required: true}
  },
  computed:{
    low(){
      return parseInt(this.num/10%10)
    },
    height(){
      return parseInt(this.num%10)
    },
  }
}
</script>

<style scoped>
.lvItemTime{
  position: relative;
  width: 190px;
  height: 72px;
  /*background-color: #0c83ae;*/
  font-size: 38px;
  line-height: 72px;
  text-align: left;
}
.whileBlock{
  float: left;
  margin-right: 8px;
  background-color: whitesmoke;
  width: 60px;
  height: 100%;
  border-radius: 5px;
  color: #06050b;
  text-align: center;
  font-size: 45px;
}
</style>